import { render, staticRenderFns } from "./ExpirationProducts.vue?vue&type=template&id=34fe870a&scoped=true&"
import script from "./ExpirationProducts.vue?vue&type=script&lang=js&"
export * from "./ExpirationProducts.vue?vue&type=script&lang=js&"
import style0 from "./ExpirationProducts.vue?vue&type=style&index=0&id=34fe870a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34fe870a",
  null
  
)

export default component.exports